import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubmitIntention } from '../../types/SubmitIntention';
import { initialMiscStoreData } from './initalMiscStoreData';
import { DataProcessingAgreement } from '../../../../domain/DataProcessingAgreement';

// Use this part of the store to store the selected variants of A/B tests.
// This way it's easy to show/hide or enable/disable certain parts at any location
// of the application for tests.
export type MiscStoreData = {
  referralDiscountCode?: string;
  discountCodeNeedsValidation: boolean;
  preferredSubmitIntention: SubmitIntention;
  dataProcessingAgreement: DataProcessingAgreement | null;
};

export const miscSlice = createSlice({
  name: 'miscellaneous',
  initialState: initialMiscStoreData,
  reducers: {
    setReferralDiscountCode: (state, action) => {
      state.referralDiscountCode = action.payload;
    },
    setDiscountCodeNeedsValidation: (state, action) => {
      state.discountCodeNeedsValidation = action.payload;
    },
    setPreferredSubmitIntention: (state, action: PayloadAction<SubmitIntention>) => {
      state.preferredSubmitIntention = action.payload;
    },
    setDataProcessingAgreement: (state, action: PayloadAction<DataProcessingAgreement>) => {
      state.dataProcessingAgreement = action.payload;
    }
  }
});

export const {
  setReferralDiscountCode,
  setDiscountCodeNeedsValidation,
  setDataProcessingAgreement
} = miscSlice.actions;

export default miscSlice.reducer;
